// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1BE_r","errors":"Errors_errors__3ZLSd"};